







































































import { Component, Vue } from "vue-property-decorator";
import { copyChannel, getChannelById } from "@/services/channels/channelsService";
import { Channel, CopyChannel } from "@/services/channels/types";
import { copyValidators } from "@/components/channels/validators";
import validate from "@/directives/validate";
import { validateForm } from "@/services/validation/validationService";

@Component({
    directives: {
        validate
    }
})
export default class ChannelCopyModal extends Vue {
    channel = {} as Channel;
    model = {} as CopyChannel;
    validators = copyValidators;

    open(channelId: string) {
        getChannelById(channelId).then(response => {
            this.channel = response;
            this.model.channelId = channelId;
            this.model.copyContent = false;
            this.model.copyUserAccess = false;
            this.model.name = this.channel.name + " Copy";
            this.model.width = this.channel.width;
            this.model.height = this.channel.height;
            this.$bvModal.show("modal-channelCopy");
        });
    }

    async confirm() {
        if (!await validateForm([this.validators])) return;
        this.$bvModal.hide("modal-channelCopy");
        copyChannel(this.model).then(() => {
            this.$emit("reload");
        });
        this.model = {} as CopyChannel;
    }

    decline() {
        this.$bvModal.hide("modal-channelCopy");
    }
}
